import { createWebHistory, createRouter } from "vue-router";
import { setLocalStorage } from "@/methods/storage";

const Home = () => import("@/views/Home/home.vue");
const About = () => import("@/views/About/about.vue");
const Products = () => import("@/views/Products/products.vue");
const Prods_PET = () => import("@/views/Products/pet-nonwoven-fabric.vue");
const ProductsDetails = () =>
  import("@/views/ProductsDetails/productsDetails.vue");
const Technology = () => import("@/views/Technology/technology.vue");
const News = () => import("@/views/News/news.vue");
const NewsDetails = () => import("@/views/NewsDetails/newsDetails.vue");
const Videos = () => import("@/views/Videos/videos.vue");
const Contacts = () => import("@/views/Contacts/contacts.vue");

const router = createRouter({
  linkActiveClass: 'border-indigo-500',
  linkExactActiveClass: 'border-indigo-700',
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      redirect: "/home",
    },
    {
      path: "/home",
      name: "Home",
      component: Home,
    },
    {
      path: "/about",
      name: "About",
      component: About,
    },
    {
      path: "/products/pet-nonwoven-fabric",
      name: "Prods_PET",
      component: Prods_PET,
    },
    {
      path: "/products",
      name: "Products",
      component: Products,
    },
    {
      path: "/productdetail/:id",
      name: "ProductsDetails",
      component: ProductsDetails
    },
    {
      path: "/technology",
      name: "Technology",
      component: Technology,
    },
    {
      path: "/news",
      name: "News",
      component: News,
    },
    {
      path: "/newsdetail/:id",
      name: "NewsDetail",
      component: NewsDetails,
    },
    {
      path: "/videos/:id",
      name: "Videos",
      component: Videos,
    },
    {
      path: "/contact",
      name: "Contacts",
      component: Contacts,
    },
    // {
    //   path: "/:pathMatch(.*)*",
    //   redirect: "/home",
    // },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: "smooth",
      };
    }
    if (savedPosition) {
      return savedPosition;
    } else {
      // 滚动到顶部
      return { top: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  setLocalStorage("misun_linkurl", to.path);
  next();
});

export default router;
